export type CampaignEditorGroup =
  | 'basics'
  | 'page'
  | 'resources'
  | 'communication'
  | 'results'

export const CAMPAIGN_EDITOR_GROUPS = [
  {
    id: 'basics',
    label: 'Editar',
    icon: 'mdi:pencil-outline',
    firstTab: 'identidade',
    title: 'Configuração da campanha',
    description:
      'Comece pelos dados gerais, defina as condições de participação e organize os documentos.',
  },
  {
    id: 'page',
    label: 'Página pública',
    icon: 'mdi:web',
    firstTab: 'template',
    title: 'A página que seu público vê',
    description:
      'Escolha o modelo e personalize o conteúdo. Os campos acompanham o template selecionado.',
  },
  {
    id: 'resources',
    label: 'Recursos',
    icon: 'mdi:puzzle-outline',
    firstTab: 'combos',
    title: 'Recursos para sua campanha',
    description:
      'Adicione ofertas, prêmios e experiências de participação conforme a necessidade da campanha.',
  },
  {
    id: 'communication',
    label: 'Divulgação',
    icon: 'mdi:bullhorn-outline',
    firstTab: 'compartilhamento',
    title: 'Divulgação e comunicação',
    description:
      'Prepare o link para compartilhar, personalize os e-mails e configure o acompanhamento dos anúncios.',
  },
  {
    id: 'results',
    label: 'Resultados',
    icon: 'mdi:chart-line',
    firstTab: 'dashboard',
    title: 'Resultados da campanha',
    description: 'Acompanhe o desempenho, os participantes e as vendas desta campanha.',
  },
] as const

export const CAMPAIGN_EDITOR_TABS = [
  {
    id: 'identidade',
    group: 'basics',
    label: 'Dados gerais',
    icon: 'mdi:tag-outline',
    help: 'Use o nome para identificar a campanha no painel. O status controla sua disponibilidade para participação.',
  },
  {
    id: 'periodo-valores',
    group: 'basics',
    label: 'Valores e período',
    icon: 'mdi:calendar-clock-outline',
    help: 'Defina quando a campanha acontece e as condições de compra. A quantidade de números ou o modo de compra sem números da sorte só pode ser definido uma vez.',
  },
  {
    id: 'certificados-regulamento',
    group: 'basics',
    label: 'Regulamento',
    icon: 'mdi:file-document-outline',
    help: 'Disponibilize as regras aos participantes e, quando houver, o certificado da campanha.',
  },
  {
    id: 'template',
    group: 'page',
    label: 'Template',
    icon: 'mdi:view-quilt-outline',
    help: 'Escolha o ponto de partida da página. Você pode trocar o modelo sem apagar o conteúdo dos outros templates.',
  },
  {
    id: 'pagina-publica',
    group: 'page',
    label: 'Conteúdo',
    icon: 'mdi:text-box-outline',
    help: 'Preencha os textos na ordem em que aparecem na página pública.',
  },
  {
    id: 'conteudo-template',
    group: 'page',
    label: 'Seções do Template 3',
    icon: 'mdi:format-list-bulleted-square',
    help: 'Complete as seções exclusivas deste modelo: topo, sobre, vantagens, dúvidas frequentes e botão flutuante.',
  },
  {
    id: 'comunicacao-midia',
    group: 'page',
    label: 'Imagens e cores',
    icon: 'mdi:palette-outline',
    help: 'Personalize a imagem principal e a identidade visual. A galeria aparece apenas nos templates que a utilizam.',
  },
  {
    id: 'links',
    group: 'page',
    label: 'Contato e links',
    icon: 'mdi:link-variant',
    help: 'Informe os canais de contato, as redes sociais e os links do rodapé. Campos opcionais podem ficar em branco.',
  },
  {
    id: 'dominio-personalizado',
    group: 'page',
    label: 'Endereço',
    icon: 'mdi:dns-outline',
    help: 'Configure o endereço da campanha, um domínio próprio ou o redirecionamento para seu site.',
  },
  {
    id: 'combos',
    group: 'resources',
    label: 'Combos',
    icon: 'mdi:package-variant',
    help: 'Crie ofertas de participação. Cada combo é salvo pelo botão do seu próprio formulário.',
  },
  {
    id: 'numeros-premiados',
    group: 'resources',
    label: 'Números premiados',
    icon: 'mdi:trophy-variant-outline',
    help: 'Associe prêmios a números específicos. Estas alterações usam o botão Salvar campanha.',
  },
  {
    id: 'roleta',
    group: 'resources',
    label: 'Roleta',
    icon: 'mdi:circle-slice-8',
    help: 'Configure as regras de giros e os prêmios. Use Salvar roleta ou o botão verde para salvar todas as alterações da roleta.',
  },
  {
    id: 'roleta-api',
    group: 'resources',
    label: 'Roleta API',
    icon: 'mdi:api',
    help: 'Configure a roleta externa, os horários vencedores e os logs de participação. Cada intervalo permite um ganhador.',
  },
  {
    id: 'gamificacao',
    group: 'resources',
    label: 'Gamificação',
    icon: 'mdi:medal-outline',
    help: 'Personalize as mensagens dos selos conquistados pelos participantes.',
  },
  {
    id: 'raspadinha-compra',
    group: 'resources',
    label: 'Raspadinha',
    icon: 'mdi:gesture-swipe',
    help: 'Uma raspadinha por compra paga. Personalize as três imagens, a área raspável e as probabilidades dos prêmios.',
  },
  {
    id: 'avatar',
    group: 'resources',
    label: 'Avatar',
    icon: 'mdi:account-edit-outline',
    help: 'Crie peças exclusivas, personalize suas camadas e publique no avatar dos participantes desta campanha.',
  },
  {
    id: 'inteligencia-artificial',
    group: 'resources',
    label: 'Inteligência artificial',
    icon: 'mdi:robot-happy-outline',
    help: 'Configure o nome, o contexto e o preço dos créditos do assistente da campanha.',
  },
  {
    id: 'pergunta',
    group: 'resources',
    label: 'Perguntas',
    icon: 'mdi:help-circle-outline',
    help: 'Crie perguntas para os participantes. Cada pergunta é salva no seu próprio formulário.',
  },
  {
    id: 'widget',
    group: 'resources',
    label: 'Incorporar no site',
    icon: 'mdi:code-tags',
    help: 'Configure o botão de compra para outro site. Salve as alterações da campanha antes de copiar o código.',
  },
  {
    id: 'compartilhamento',
    group: 'communication',
    label: 'Compartilhamento',
    icon: 'mdi:share-variant-outline',
    help: 'Defina o título, a descrição e a imagem que acompanham o link em redes sociais e aplicativos de mensagem.',
  },
  {
    id: 'email',
    group: 'communication',
    label: 'E-mail',
    icon: 'mdi:email-outline',
    help: 'Personalize a mensagem enviada ao participante após a confirmação do pagamento.',
  },
  {
    id: 'pixels',
    group: 'communication',
    label: 'Pixels e anúncios',
    icon: 'mdi:chart-timeline-variant',
    help: 'Configuração opcional para quem acompanha campanhas no Meta ou no Google. Preencha apenas as integrações utilizadas.',
  },
  {
    id: 'dashboard',
    group: 'results',
    label: 'Resultados',
    icon: 'mdi:chart-line',
    help: '',
  },
] as const

export type CampaignEditorTab = (typeof CAMPAIGN_EDITOR_TABS)[number]['id']

export function resolveCampaignEditorTab(value?: string | null): CampaignEditorTab {
  const candidate = value?.replace(/^#/, '')
  return CAMPAIGN_EDITOR_TABS.find((tab) => tab.id === candidate)?.id ?? 'identidade'
}

export function getCampaignEditorTab(value?: string | null) {
  return CAMPAIGN_EDITOR_TABS.find((tab) => tab.id === resolveCampaignEditorTab(value))!
}

export function getCampaignEditorGroup(value?: string | null) {
  return CAMPAIGN_EDITOR_GROUPS.find(
    (group) => group.id === getCampaignEditorTab(value).group
  )!
}

/** Campos efetivamente renderizados pelas páginas públicas, preservando os dados ao trocar o modelo. */
export function campaignTemplateCapabilities(templateKey?: string | null) {
  const isTemplate3 = templateKey === 'template-3'
  return {
    isTemplate3,
    gallery: !isTemplate3,
    reviews: !isTemplate3,
    detailedContent: !isTemplate3,
    customCta: isTemplate3,
  }
}

export function campaignFieldTab(field: string): CampaignEditorTab | null {
  if (field === 'public_template_key') return 'template'
  if (field.startsWith('widget_embed_')) return 'widget'
  if (field.startsWith('template3_')) return 'conteudo-template'
  if (/^(name|status|prize_description)$/.test(field)) return 'identidade'
  if (
    /^(starts_at|ends_at|price|total_numbers|donation_only|min_quantity|max_quantity|doey_seller_id|pix_qr)/.test(
      field
    )
  )
    return 'periodo-valores'
  if (/^(regulation|certificate)/.test(field)) return 'certificados-regulamento'
  if (/^(fb_|g_pixel|gtm_|ga4_)/.test(field)) return 'pixels'
  if (/^(email_|login_url)/.test(field)) return 'email'
  if (/^(slug|custom_domain|public_page_url)$/.test(field)) return 'dominio-personalizado'
  if (/^(public_share_|public_page_title)/.test(field)) return 'compartilhamento'
  if (/^(public_contact|public_social|whatsapp)/.test(field)) return 'links'
  if (
    /^(main_image|carousel_|primary_color|secondary_color|button_color|highlight_color)/.test(
      field
    )
  )
    return 'comunicacao-midia'
  if (/^premiated_/.test(field)) return 'numeros-premiados'
  if (/^(title|description|cta_text|public_)/.test(field)) return 'pagina-publica'
  return null
}
